import axios from 'axios';

export const getGroup = async () => {
    return await axios.get('/api/erp/group/list');
};
